export default "__VITE_ASSET__Za2Uy94H__"